const parseDurationSeconds = (duration) => {
  if (typeof duration === 'number') return duration;
  if (typeof duration === 'string') {
    const val = Number.parseFloat(duration.replace('s', ''));
    return Number.isFinite(val) ? val : 0;
  }
  return 0;
};

export const getCumulativeEtaSeconds = (routeData) => {
  if (!routeData?.legs) return [];
  const acc = [];
  routeData.legs
    .map((leg) => parseDurationSeconds(leg?.duration))
    .reduce((sum, cur) => {
      const next = sum + cur;
      acc.push(next);
      return next;
    }, 0);
  return acc;
};

export const getLegStartsMeters = (routeData) => {
  if (!routeData?.legs?.length) return [];
  const starts = [0];
  let running = 0;
  routeData.legs.forEach((leg) => {
    const dist = Number.isFinite(leg?.distanceMeters) ? Number(leg.distanceMeters) : 0;
    running += dist;
    starts.push(running);
  });
  return starts;
};
